export const TIME_OUT_RENDER_CHART = 300;
